import React from "react";
import Navbar from "../Navbar/Navbar";
import "./ResumeHoc.css";
import { CustomSidebar } from "../Sidebar/Custom-Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faUserGraduate,
  faUserTie,
  faWindowRestore,
  faList,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "antd";


/**
 * Reusable HOC
 * @param {React.Component} Component - The page to wrap
 * @param {Object} options - Layout options
 * @param {boolean} options.withSidebar - Show sidebar or not
 */
const LayoutHOC = (Component, { withSidebar = false } = {}) =>
  function WrappedComponent(props) {
    
    return (
      <>
      <div className="resume-hoc-container">
        <Navbar />
        <div className="hoc-container">
          <Row gutter={[16, 16]} style={{ width: "100%" }}>
         
            <Col span={24} className="hoc-right-container">
              <Component {...props} />
            </Col>
          </Row>
        </div>
      </div>
      </>
    );
  };

export default LayoutHOC;
